import { observable, computed } from 'mobx'

class Store {
  @observable bottom = '24px'

  setBottom = bottom => {
    this.bottom = bottom ? bottom : '24px'
  }

  @computed
  get hasBottom() {
    return this.bottom != '24px'
  }
}

export default new Store()
